import React, { useState, useEffect, useContext } from 'react';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import {
    DownOutlined,
    RiseOutlined,
    NodeExpandOutlined,
    SisternodeOutlined,
    CiCircleTwoTone,
    SlidersOutlined,
    NotificationOutlined,
} from '@ant-design/icons';
import { Affix, Button, Dropdown, Menu, message, Radio, Typography, Spin } from 'antd';
import styles from './AppLayout.module.css';
const { Title } = Typography;

export const NavCard = (props) => {
    return (
        <Affix offsetTop={1}>
            <div>
                <div className={styles.card}>
                    <div className={styles.container}>
                        <TopRadios
                            livMenu={props.livMenu}
                            setLiveMenu={props.setLiveMenu}
                            keys={props.livMenu.topMenu == 'R' ? 'R' : 'S'}
                        />
                        {props.livMenu.topMenu !== 'K' && (
                            <>
                                {props.load ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : props.livMenu.topMenu === 'R' ? (
                                    <SelectorRel
                                        rel={props.rel}
                                        // rele={props.usrRel.substr(10, 2)}
                                        rele={props.usrRel ? props.usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                        setUsrRel={props.setUsrRel}
                                        setSubmit={props.setSubmit}
                                        submit={props.submit}
                                    />
                                ) : (
                                    <SelectorScheduled usrSch={props.usrSch} setUsrSch={props.setUsrSch} />
                                )}
                            </>
                        )}
                        <br />
                        <br />
                        {/* <br /> */}
                        {props.livMenu.topMenu !== 'K' && (
                            <>
                                <ColoredLine color="#D1D6DF" />
                                <Title level={5}>Areas</Title>
                                {props.livMenu.topMenu === 'R' ? (
                                    <DropMenus
                                        cci={'/'}
                                        bulkCatData={props.bulkCatData}
                                        connector={'/connector_changes'}
                                        category={'/category_changes'}
                                        bulk_category={'/bulk_catgeory_update'}
                                        livMenu={props.livMenu}
                                        keys={props.livMenu.botMenu}
                                    />
                                ) : (
                                    <DropMenus
                                        cci={'/weekly_cci_apps'}
                                        connector={'/weekly_connector_changes'}
                                        category={'/weekly_category_changes'}
                                        web_category={'/weekly_web_category_changes'}
                                        livMenu={props.livMenu}
                                        keys={props.livMenu.botMenu}
                                    />
                                )}
                            </>
                        )}
                        {/* data */}
                        {/* {props.bulkCatData["exist"] == 1 &&
            props.bulkCatData["data"].length > 0 ? (
              <>
                <br />
                <br />
                <ColoredLine color="#D1D6DF" />
                <Menu>
                  <Button>
                    <NavLink to={"/bulk_catgeory_update"}>
                      Bulk Category Changes
                    </NavLink>
                  </Button>
                </Menu>
              </>
            ) : (
              <></>
            )} */}
                    </div>
                </div>
                <br />
                <div className={styles.card}>
                    <div className={styles.container}>
                        <br />
                        <Title level={5}>About</Title>
                        <ColoredLine color="#D1D6DF" />
                        <p
                            // type="secondary"
                            // ellipsis
                            // className={styles.blockWithText}
                            style={{
                                fontFamily: 'Graphik Semibold; sans-serif',
                                fontSize: '14px',
                            }}
                        >
                            The Product Change Notification portal provides a preview of upcoming product changes along
                            with pro-active subscription based notifications tailored to a specific product
                            feature/capability. As an example the portal can be used to review and subscribe to
                            notifications about upcoming additions and changes to supported Apps or Categories.
                        </p>
                        <ColoredLine color="#D1D6DF" />
                    </div>
                </div>
            </div>
        </Affix>
    );
};

export function ScrollToTop({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname != '/xyz') window.scrollTo(0, 0);
    }, [pathname]);

    return children;
}

// export default ScrollToTop;

export const DropMenus = (props) => {
    // const location = useLocation();

    useEffect(() => {
        // console.log("reload");
        // console.log('menu - ' + props.livMenu.botMenu, props.keys);
    }, [props.keys]);

    const menu = (
        <Menu
            // mode="horizontal"
            // style={{ backgroundColor: "#EEF0F3", height: "35px" }}
            // defaultSelectedKeys={path.includes("connector") ? "2" : "1"}
            // defaultSelectedKeys={props.livMenu.botMenu === "con" ? "1" : "2"}
            // defaultSelectedKeys={props.keys}
            selectedKeys={props.keys}
        >
            {/* <Space direction="vertical"> */}
            <Menu.Item key="1" icon={<CiCircleTwoTone />}>
                <NavLink to={props.cci}>CCI Changes</NavLink>
            </Menu.Item>

            {/* Show Connector Changes only for Weekly (not Release) */}
            {props.livMenu.topMenu === 'S' && (
                <Menu.Item key="2" icon={<RiseOutlined />}>
                    <NavLink to={props.connector}>Connector Changes</NavLink>
                </Menu.Item>
            )}

            <Menu.Item key="3" icon={<SlidersOutlined />}>
                <NavLink to={props.category}>Top App Category Changes</NavLink>
            </Menu.Item>

            {props.livMenu.topMenu === 'R' &&
            props.bulkCatData['exist'] == 1 &&
            props.bulkCatData['data'].length > 0 ? (
                <Menu.Item key="4" icon={<NotificationOutlined />}>
                    <NavLink to={props.bulk_category}>Bulk App Category Changes</NavLink>
                </Menu.Item>
            ) : (
                <></>
            )}

            {props.livMenu.topMenu === 'S' ? (
                <Menu.Item key="5" icon={<NotificationOutlined />}>
                    <NavLink to={props.web_category}>Web Category Changes</NavLink>
                </Menu.Item>
            ) : (
                <></>
            )}

            {/* </Space> */}
        </Menu>
    );

    return (
        <div
            style={{
                // paddingLeft: "24px",
                paddingRight: '24px',
                paddingTop: '4px',
                // width: "40px",
            }}
        >
            {/* <Row>
        <Col span={4} />
        <Col span={14}> */}
            <Dropdown overlay={menu}>
                <Button
                    style={{
                        width: '98%',
                        textAlign: 'left',
                        display: 'flex',
                        justifyContent: 'space-between', // Distribute space between text and icon
                        alignItems: 'center', // Center text and icon vertically
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', // Ensure text does not overflow
                        whiteSpace: 'nowrap', // Prevent text from wrapping
                    }}
                >
                    {props.livMenu.botMenu === '1'
                        ? 'CCI Changes'
                        : props.livMenu.botMenu === '2'
                        ? 'Connector Changes'
                        : props.livMenu.botMenu === '3'
                        ? 'Top App Category Changes'
                        : props.livMenu.botMenu === '4' &&
                          props.bulkCatData['exist'] == 1 &&
                          props.bulkCatData['data'].length > 0
                        ? 'Bulk App Category Changes'
                        : props.livMenu.botMenu === '5'
                        ? 'Web Category Changes'
                        : ''}
                    <DownOutlined style={{ float: 'right', paddingTop: '6px' }} />
                </Button>
            </Dropdown>

            {/* </Col>
      </Row> */}
            {/* <ColoredLine color="grey" /> */}
        </div>
    );
};

export const TopRadios = (props) => {
    const history = useHistory();
    const path = history.location.pathname;

    useEffect(() => {
        switch (path) {
            case '/':
                props.setLiveMenu({ release: false, topMenu: 'R', botMenu: '1' });
                // console.log("r, cci", path);
                break;
            case '/category_changes':
                props.setLiveMenu({ release: false, topMenu: 'R', botMenu: '3' });
                // console.log("r, con", path);
                break;
            case '/bulk_catgeory_update':
                props.setLiveMenu({ release: false, topMenu: 'R', botMenu: '4' });
                // console.log("r, bulk", path);
                break;
            case '/weekly_cci_apps':
                props.setLiveMenu({ release: true, topMenu: 'S', botMenu: '1' });
                // console.log("s, cci", path);
                break;
            case '/weekly_connector_changes':
                props.setLiveMenu({ release: true, topMenu: 'S', botMenu: '2' });
                // console.log("s, con", path);
                break;
            case '/weekly_category_changes':
                props.setLiveMenu({ release: true, topMenu: 'S', botMenu: '3' });
                // console.log("s, con", path);
                break;
            case '/weekly_web_category_changes':
                props.setLiveMenu({ release: true, topMenu: 'S', botMenu: '5' });
                // console.log("s, con", path);
                break;
            case '/known_issues_tracker':
                props.setLiveMenu({ release: false, topMenu: 'K', botMenu: '1' });
                // console.log("known issues", path);
                break;
            default:
            // console.log(`Sorry, we are out of ${path}.`);
        }
    }, [path]);

    const menuSelR = () => {
        props.setLiveMenu({ release: false, topMenu: 'R', botMenu: '1' });
        history.push('/');
    };

    const menuSelS = () => {
        props.setLiveMenu({ release: true, topMenu: 'S', botMenu: '1' });
        history.push('/weekly_cci_apps');
    };

    const menuSelK = () => {
        props.setLiveMenu({ release: false, topMenu: 'K', botMenu: '1' });
        history.push('/known_issues_tracker');
    };

    const getCurrentLabel = () => {
        if (props.livMenu.topMenu === 'R') return 'Release Changes';
        if (props.livMenu.topMenu === 'S') return 'Weekly Changes';
        if (props.livMenu.topMenu === 'K') return 'Known Issues Tracker';
        return 'Release Changes';
    };

    const menu = (
        <Menu selectedKeys={[props.livMenu.topMenu]}>
            <Menu.Item key="R" onClick={menuSelR}>
                Release Changes
            </Menu.Item>
            <Menu.Item key="S" onClick={menuSelS}>
                Weekly Changes
            </Menu.Item>
            <Menu.Item key="K" onClick={menuSelK}>
                Known Issues Tracker
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            <br />
            {/* <ColoredLine color="#D1D6DF" /> */}
            <Title level={5}>Type of Notifications</Title>
            {/* <ColoredLine color="#D1D6DF" /> */}
            <Dropdown overlay={menu}>
                <Button
                    style={{
                        width: '98%',
                        textAlign: 'left',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        marginTop: '4px',
                    }}
                >
                    {getCurrentLabel()}
                    <DownOutlined style={{ float: 'right', paddingTop: '6px' }} />
                </Button>
            </Dropdown>
            <br />
        </>
    );
};

export const ColoredLine = ({ color }) => (
    <hr
        style={{
            border: 'none',
            height: '0.08px',
            color: color,
            backgroundColor: color,
        }}
    />
);

export const SelectorRel = (props) => {
    // const [inp, setInp] = useState("");

    function onChange(value) {
        // setInp(inp);
        if (props.rele !== value.key) {
            message.info(`Release snapshot_v${value.key}_0_0`);
            // console.log(value.key);
            props.setUsrRel('snapshot_v' + value.key + '_0_0');
            props.setSubmit(!props.submit);
        }
    }

    const menu = (
        <Menu onClick={onChange}>
            <Menu.Item key={props.rel} icon={<NodeExpandOutlined />}>
                {'Release ' + props.rel}
            </Menu.Item>
            <Menu.Item key={props.rel - 1} icon={<NodeExpandOutlined />}>
                {'Release ' + (props.rel - 1)}
            </Menu.Item>
            <Menu.Item key={props.rel - 2} icon={<NodeExpandOutlined />}>
                {'Release ' + (props.rel - 2)}
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <Button
                style={{
                    width: '170px',
                    textAlign: 'left',
                    marginTop: '10px',
                }}
                icon={<NodeExpandOutlined />}
            >
                {'Release ' + props.rele}
                <DownOutlined style={{ float: 'right', paddingTop: '6px' }} />
            </Button>
        </Dropdown>
    );
};

export const SelectorScheduled = (props) => {
    // const [chngItem, setChngItem] = useState("Scheduled");

    function onChng(value) {
        if (props.usrSch !== value.key) {
            message.info(value.key);
            props.setUsrSch(value.key);
        }

        // setUsrRel("snapshot_v" + value + "_0_0");
        // setSubmit(!submit);
    }

    const menu = (
        <Menu onClick={onChng}>
            <Menu.Item key={'Scheduled'} icon={<SisternodeOutlined />}>
                {'Scheduled'}
            </Menu.Item>
            <Menu.Item key={'Deployed'} icon={<SisternodeOutlined />}>
                {'Deployed'}
            </Menu.Item>
            <Menu.Item key={'All'} icon={<SisternodeOutlined />}>
                {'All'}
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <Button style={{ width: '170px', textAlign: 'left', marginTop: '10px' }} icon={<SisternodeOutlined />}>
                {props.usrSch}
                <DownOutlined style={{ float: 'right', paddingTop: '6px' }} />
            </Button>
        </Dropdown>
    );

    // function onChng(value) {
    //   message.info(value);
    //   setChngItem(value);
    //   // setUsrRel("snapshot_v" + value + "_0_0");
    //   // setSubmit(!submit);
    // }

    // return (
    //   <Select
    //     value={chngItem}
    //     showSearch
    //     style={{
    //       width: "80%",
    //       marginTop: "10px",
    //       // marginLeft: "10px",
    //     }}
    //     placeholder="Select Schedule"
    //     optionFilterProp="children"
    //     onChange={onChng}
    //   >
    //     <Option value={"Scheduled"}>Scheduled</Option>
    //     <Option value={"Deployed"}>Deployed</Option>
    //     <Option value={"All"}>All</Option>
    //   </Select>
    // );
};
